import { render } from "./PopinMedia.vue?vue&type=template&id=eb8f9c5c"
import script from "./PopinMedia.vue?vue&type=script&lang=js"
export * from "./PopinMedia.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__